import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismBanner } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface HotelPricingAssistantAutopilotBannerSignature {
  Args: {
    onAutopilotBannerClose: () => void;
  };
}

export default class HotelPricingAssistantAutopilotBanner extends Component<HotelPricingAssistantAutopilotBannerSignature> {
  @service declare intl: Services['intl'];

  @service declare router: Services['router'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get bannerPrimaryAction() {
    return {
      label: this.intl.t(
        'pricing_assistant.autopilot.button.navigate_to_settings',
      ),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      action: this.redirectToAutopilotSettings,
    };
  }

  @action
  redirectToAutopilotSettings(): void {
    this.router.transitionTo('hotel.settings.autopilot');
  }

  <template>
    <PrismBanner
      @bannerMessage={{t "pricing_assistant.autopilot.banner.message"}}
      @bannerStyle="intelligence"
      @close={{@onAutopilotBannerClose}}
      @hasCta={{true}}
      @icon="automation"
      @isOneLine={{true}}
      @primaryAction={{this.bannerPrimaryAction}}
    />
  </template>
}
